import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-progress",
  "use": "icon-progress-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"icon-progress\"><g fill=\"none\" fill-rule=\"evenodd\"><circle fill=\"#FF5600\" cx=\"6\" cy=\"6\" r=\"6\" /><path d=\"M2 5.665a.665.665 0 101.33 0 .665.665 0 00-1.33 0zm3.335 0a.665.665 0 101.33 0 .665.665 0 00-1.33 0zm3.335 0a.665.665 0 001.33 0 .665.665 0 00-1.33 0z\" fill=\"#FFF\" fill-rule=\"nonzero\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol